<ng-container>
	<div class="actions">
		<app-button
			appearance="secondary"
			size="s"
			(clicked)="onToggleDialog(true)"
		>
			{{ 'watchList.actions.delete' | translate }}
		</app-button>
	</div>
</ng-container>

<ng-template [(tuiDialog)]="isOpenConfirmDeleteAsset">
	<app-confirm-dialog
		[dialogTitle]="'confirmDialog.watchListTitle'"
		[cancelText]="'confirmDialog.cancel'"
		[confirmText]="'confirmDialog.confirm'"
		[isLoadingConfirm]="isLoadingConfirm()"
		(onCancel)="onToggleDialog(false)"
		(onConfirm)="onDeleteAsset()"
	/>
</ng-template>
